import { default as api } from 'config/adminApiConf.js';

export const addContentService = async (data = {}) => {
	try {
		let result = await api.post('/content-management/create-home-content', data);
		return result;
	} catch (error) {
		return error;
	}
};

export const getContentService = async (pageType = 1) => {
	try {
		let result = await api.get(`/content-management/get-page-content/${pageType}`);
		return result;
	} catch (error) {
		return error;
	}
};
